import React from "react";

import { useAppSelector } from "../../hooks";
import { getCurrentUser } from "../../store/userStore";
import RubbleTicketView from "./rubble-ticket-view";
import RubbleDriverForm from "./rubble-driver-form";

/**
 * /rubble/:id - the rubble counterpart to /ticket/:id. Anonymous drivers get
 * the dispatch form, signed-in staff the full edit view.
 */
const RubbleTicketRoute = () => {
  const user = useAppSelector(getCurrentUser);

  return user ? <RubbleTicketView /> : <RubbleDriverForm />;
};

export default RubbleTicketRoute;
